import React, { useState } from 'react';
import { Accordion } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaCheck, FaCreditCard, FaTrashAlt, FaEdit, FaStar, FaPlus, FaShieldAlt, FaUniversity } from 'react-icons/fa';
import { SiVisa, SiMastercard, SiAmericanexpress } from 'react-icons/si';
import CreditCardType from './creditCardType';
import { getElakayLanguageContext } from "./dataElakay";

let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
// Current language source: the app-wide one (always up to date after a language switch), else
// the infoSource this module last rendered with.
const __elakayLanguageSource = () => getElakayLanguageContext?.() || __elakayInfoSource;
const __elakayText = (key, fallback) =>
  __elakayLanguageSource()?.laguangeElakay?.("frontElakayHardcodedText", __elakayLanguageSource().languageAPI)?.["paymentmethodsredesign"]?.[key] || fallback;

// Votre composant existant

// ===== STYLES CSS PREMIUM =====


const premiumStyles = `
/* ===== FONTS ===== */
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&family=Inter:wght@400;500;600&display=swap');

/* ===== ANIMATIONS ===== */
@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(30px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes shimmer {
    0% { background-position: -200% center; }
    100% { background-position: 200% center; }
}

@keyframes pulse {
    0%, 100% { transform: scale(1); }
    50% { transform: scale(1.02); }
}

/* ===== CONTAINER ===== */
.payment-premium-container {
    // background: linear-gradient(135deg, #0f0c29 0%, #302b63 50%, #24243e 100%);
    min-height: 100vh;
    padding: 40px 20px;
    font-family: 'Poppins', sans-serif;
    position: relative;
    overflow: hidden;
}

.payment-premium-container::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    // background: 
    //     radial-gradient(circle at 20% 20%, rgba(102, 126, 234, 0.15) 0%, transparent 40%),
    //     radial-gradient(circle at 80% 80%, rgba(118, 75, 162, 0.15) 0%, transparent 40%),
    //     radial-gradient(circle at 50% 50%, rgba(255, 255, 255, 0.02) 0%, transparent 50%);
    pointer-events: none;
}

/* ===== MAIN CARD ===== */
.payment-premium-card {
    background: rgba(255, 255, 255, 0.98);
    border-radius: 28px;
    box-shadow: 
        0 30px 100px rgba(0, 0, 0, 0.4),
        0 0 0 1px rgba(255, 255, 255, 0.1);
    overflow: hidden;
    max-width: 950px;
    margin: 0 auto;
    position: relative;
    z-index: 1;
    animation: fadeInUp 0.8s cubic-bezier(0.34, 1.56, 0.64, 1);
}

/* ===== HEADER ===== */
.payment-premium-header {
    background: linear-gradient(135deg, #f8fafc 0%, #eef9fc 100%);
    padding: 36px 44px;
    position: relative;
    overflow: hidden;
    border-bottom: 1px solid #e2e8f0;
}

.payment-header-content {
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    gap: 20px;
}

.payment-header-icon-wrapper {
    background: linear-gradient(135deg, #007399 0%, #00a4d8 100%);
    padding: 18px;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 10px 30px rgba(0, 115, 153, 0.3);
}

.payment-header-text h3 {
    color: #0f172a;
    font-size: 1.85rem;
    font-weight: 700;
    margin: 0 0 6px 0;
    letter-spacing: -0.5px;
}

.payment-header-text p {
    color: #64748b;
    font-size: 0.95rem;
    margin: 0;
    font-weight: 400;
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
}

/* ===== HEADER POLICY LINK ===== */
.header-policy-link {
    color: #007399 !important;
    text-decoration: none !important;
    font-weight: 500;
    padding: 4px 12px;
    background: rgba(0, 115, 153, 0.08);
    border-radius: 20px;
    transition: all 0.3s ease;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 0.85rem;
    border: 1px solid rgba(0, 115, 153, 0.2);
}

.header-policy-link:hover {
    color: #004b63 !important;
    background: rgba(0, 115, 153, 0.15);
    border-color: rgba(0, 115, 153, 0.3);
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

/* ===== BODY ===== */
.payment-premium-body {
    padding: 36px 44px;
    background: linear-gradient(180deg, #f8fafc 0%, #ffffff 100%);
}

/* ===== SECTION TITLE ===== */
.payment-section-title {
    font-size: 1.15rem;
    font-weight: 600;
    color: #1a1a2e;
    margin-bottom: 24px;
    display: flex;
    align-items: center;
    gap: 12px;
}

.payment-section-title svg {
    color: #007399;
    filter: drop-shadow(0 2px 4px rgba(0, 115, 153, 0.3));
}

/* ===== ACCORDION ===== */
.payment-premium-accordion {
    border: none !important;
    border-radius: 20px !important;
    overflow: hidden;
    box-shadow: 
        0 4px 24px rgba(0, 0, 0, 0.06),
        0 0 0 1px rgba(0, 0, 0, 0.03);
}

.payment-premium-accordion .accordion-item {
    border: none !important;
    background: #ffffff !important;
    transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
    animation: fadeInUp 0.5s ease-out both;
}

.payment-premium-accordion .accordion-item:not(:last-child) {
    border-bottom: 1px solid #f0f2f7 !important;
}

.payment-premium-accordion .accordion-item:nth-child(1) { animation-delay: 0.1s; }
.payment-premium-accordion .accordion-item:nth-child(2) { animation-delay: 0.2s; }
.payment-premium-accordion .accordion-item:nth-child(3) { animation-delay: 0.3s; }
.payment-premium-accordion .accordion-item:nth-child(4) { animation-delay: 0.4s; }

.payment-premium-accordion .accordion-item:hover {
    background: #fafbff !important;
}

.payment-premium-accordion .accordion-button {
    padding: 22px 28px;
    background: transparent !important;
    box-shadow: none !important;
    gap: 20px;
    transition: all 0.3s ease;
}

.payment-premium-accordion .accordion-button:not(.collapsed) {
    background: linear-gradient(135deg, #f8f9ff 0%, #f0f4ff 100%) !important;
}

.payment-premium-accordion .accordion-button::after {
    width: 24px;
    height: 24px;
    background-size: 24px;
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23667eea'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e") !important;
    transition: transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.payment-premium-accordion .accordion-button:not(.collapsed)::after {
    transform: rotate(-180deg);
}

.payment-premium-accordion .accordion-body {
    padding: 0 28px 28px !important;
    background: linear-gradient(180deg, #f8f9ff 0%, #ffffff 100%) !important;
}

/* ===== CARD HEADER ITEM ===== */
.card-header-item {
    display: flex;
    align-items: center;
    gap: 18px;
    flex: 1;
}

.card-brand-icon {
    width: 60px;
    height: 42px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.6rem;
    color: #ffffff;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    transition: all 0.3s ease;
}

.card-brand-icon.visa {
    background: linear-gradient(135deg, #1a1f71 0%, #0066b2 100%);
}

.card-brand-icon.mastercard {
    background: linear-gradient(135deg, #eb001b 0%, #f79e1b 100%);
}

.card-brand-icon.amex {
    background: linear-gradient(135deg, #006fcf 0%, #00175a 100%);
}

.card-brand-icon.discover {
    background: linear-gradient(135deg, #ff6000 0%, #f76b1c 100%);
}

.card-brand-icon.diners {
    background: linear-gradient(135deg, #0079be 0%, #00518e 100%);
}

.card-brand-icon.jcb {
    background: linear-gradient(135deg, #0066a1 0%, #00417a 100%);
}

.card-brand-icon.unionpay {
    background: linear-gradient(135deg, #e31837 0%, #c8102e 100%);
}

.card-brand-icon.default {
    background: linear-gradient(135deg, #007399 0%, #00a4d8 100%);
}

.accordion-button:hover .card-brand-icon {
    transform: scale(1.08) rotate(-3deg);
}

.card-info-text {
    flex: 1;
}

.card-info-number {
    font-size: 1.05rem;
    font-weight: 600;
    color: #1a1a2e;
    letter-spacing: 0.5px;
    margin-bottom: 4px;
}

.card-info-expiry {
    font-size: 0.88rem;
    color: #6b7280;
    font-weight: 500;
}

/* ===== DEFAULT BADGE ===== */
.default-card-badge {
    background: linear-gradient(135deg, #10b981 0%, #059669 100%);
    color: #ffffff;
    padding: 8px 16px;
    border-radius: 24px;
    font-size: 0.78rem;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 6px;
    box-shadow: 0 4px 14px rgba(16, 185, 129, 0.35);
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

/* ===== CARD DETAIL SECTION ===== */
.card-detail-section {
    padding-top: 24px;
}

.card-visual-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px 0;
}

/* ===== BILLING SECTION ===== */
.billing-info-section {
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    border-radius: 20px;
    padding: 28px;
    border: 1px solid rgba(0, 0, 0, 0.04);
    height: 100%;
    display: flex;
    flex-direction: column;
}

.billing-info-title {
    font-size: 1rem;
    font-weight: 600;
    color: #1a1a2e;
    margin-bottom: 18px;
    display: flex;
    align-items: center;
    gap: 10px;
}

.billing-info-title svg {
    color: #007399;
}

.billing-info-content {
    font-size: 0.95rem;
    color: #4b5563;
    line-height: 1.9;
}

.billing-info-content strong {
    color: #1a1a2e;
    font-weight: 600;
}

/* ===== ACTION BUTTONS ===== */
.card-actions {
    display: flex;
    gap: 14px;
    margin-top: auto;
    padding-top: 24px;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
}

.action-buttons-group {
    display: flex;
    gap: 12px;
}

.btn-card-delete {
    background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
    border: none;
    padding: 14px 26px;
    border-radius: 14px;
    color: #ffffff;
    font-weight: 600;
    font-size: 0.9rem;
    display: flex;
    align-items: center;
    gap: 8px;
    box-shadow: 0 6px 20px rgba(239, 68, 68, 0.3);
    transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
    cursor: pointer;
}

.btn-card-delete:hover {
    transform: translateY(-3px);
    box-shadow: 0 10px 30px rgba(239, 68, 68, 0.4);
}

.btn-card-edit {
    background: linear-gradient(135deg, #007399 0%, #00a4d8 100%);
    border: none;
    padding: 14px 26px;
    border-radius: 14px;
    color: #ffffff;
    font-weight: 600;
    font-size: 0.9rem;
    display: flex;
    align-items: center;
    gap: 8px;
    box-shadow: 0 6px 20px rgba(0, 115, 153, 0.3);
    transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
    cursor: pointer;
}

.btn-card-edit:hover {
    transform: translateY(-3px);
    box-shadow: 0 10px 30px rgba(0, 115, 153, 0.4);
}

.link-default-card {
    color: #007399;
    font-weight: 600;
    font-size: 0.95rem;
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: 8px;
    transition: all 0.3s ease;
    cursor: pointer;
    padding: 10px 16px;
    border-radius: 12px;
    background: rgba(0, 115, 153, 0.08);
}

.link-default-card:hover {
    color: #004b63;
    background: rgba(0, 115, 153, 0.15);
    transform: translateX(4px);
}

/* ===== SECURITY BADGE ===== */
.security-info-badge {
    display: flex;
    align-items: center;
    gap: 10px;
    justify-content: center;
    margin-top: 28px;
    padding: 16px 24px;
    background: linear-gradient(135deg, rgba(16, 185, 129, 0.08) 0%, rgba(5, 150, 105, 0.12) 100%);
    border-radius: 14px;
    color: #059669;
    font-size: 0.9rem;
    font-weight: 500;
    border: 1px solid rgba(16, 185, 129, 0.15);
}

.security-info-badge svg {
    font-size: 1.1rem;
}

/* ===== ADD CARD BUTTON ===== */
.btn-add-new-card {
    background: linear-gradient(135deg, #007399 0%, #00a4d8 100%);
    border: none;
    padding: 18px 36px;
    border-radius: 16px;
    color: #ffffff;
    font-weight: 600;
    font-size: 1rem;
    display: flex;
    align-items: center;
    gap: 12px;
    box-shadow:
        0 10px 30px rgba(0, 115, 153, 0.3),
        0 0 0 1px rgba(255, 255, 255, 0.05);
    transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
    cursor: pointer;
    margin-top: 28px;
    margin-left: auto;
    position: relative;
    overflow: hidden;
}

.btn-add-new-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent);
    transition: left 0.5s ease;
}

.btn-add-new-card:hover::before {
    left: 100%;
}

.btn-add-new-card:hover {
    transform: translateY(-4px) scale(1.02);
    box-shadow:
        0 15px 45px rgba(0, 115, 153, 0.4),
        0 0 0 1px rgba(255, 255, 255, 0.1);
}

/* ===== EMPTY STATE ===== */
.empty-payment-state {
    text-align: center;
    padding: 70px 50px;
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    border-radius: 24px;
    margin: 20px 0;
    border: 2px dashed rgba(0, 115, 153, 0.2);
}

.empty-payment-icon {
    width: 130px;
    height: 130px;
    background: linear-gradient(135deg, #e0f4fa 0%, #b8e8f5 100%);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 28px;
    font-size: 3.5rem;
    color: #007399;
    box-shadow: 0 10px 40px rgba(0, 115, 153, 0.2);
    animation: pulse 2s ease-in-out infinite;
}

.empty-payment-title {
    font-size: 1.35rem;
    font-weight: 700;
    color: #1a1a2e;
    margin-bottom: 10px;
}

.empty-payment-text {
    font-size: 1rem;
    color: #6b7280;
    max-width: 320px;
    margin: 0 auto;
    line-height: 1.6;
}

/* ===== HEADER STRIPE LINK ===== */
.header-stripe-link {
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0.05) 100%);
    border: 1px solid rgba(255, 255, 255, 0.25);
    padding: 12px 24px;
    border-radius: 14px;
    color: #ffffff;
    font-weight: 600;
    font-size: 0.9rem;
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
    backdrop-filter: blur(10px);
    margin-left: auto;
    position: relative;
    overflow: hidden;
}

.header-stripe-link::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    transition: left 0.5s ease;
}

.header-stripe-link:hover::before {
    left: 100%;
}

.header-stripe-link:hover {
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.25) 0%, rgba(255, 255, 255, 0.15) 100%);
    border-color: rgba(255, 255, 255, 0.4);
    transform: translateY(-2px) scale(1.02);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
}

.header-stripe-link:active {
    transform: translateY(0) scale(0.98);
}

/* ===== BANK ACCOUNTS ===== */
.bank-section-title {
    margin-top: 36px;
}

.bank-item-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 16px;
    padding: 20px 24px;
    border-radius: 18px;
    background: linear-gradient(180deg, #f8f9ff 0%, #ffffff 100%);
    border: 1px solid rgba(0, 0, 0, 0.05);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.04);
    margin-bottom: 14px;
}

.bank-item-info {
    display: flex;
    align-items: center;
    gap: 16px;
}

.bank-icon-wrapper {
    width: 54px;
    height: 54px;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    font-size: 1.4rem;
    background: linear-gradient(135deg, #007399 0%, #00a4d8 100%);
    box-shadow: 0 6px 16px rgba(0, 115, 153, 0.3);
    flex-shrink: 0;
}

.bank-info-name {
    font-size: 1rem;
    font-weight: 600;
    color: #1a1a2e;
}

.bank-info-last4 {
    font-size: 0.88rem;
    color: #6b7280;
    font-weight: 500;
}

.bank-item-actions {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
}

/* ===== RESPONSIVE ===== */
@media (max-width: 768px) {
    .payment-premium-container {
        padding: 20px 16px;
    }

    .payment-premium-header,
    .payment-premium-body {
        padding: 28px 24px;
    }

    .payment-header-content {
        flex-direction: column;
        text-align: center;
    }

    .payment-header-text h3 {
        font-size: 1.5rem;
    }

    .card-actions {
        flex-direction: column;
        align-items: stretch;
    }

    .action-buttons-group {
        width: 100%;
    }

    .btn-card-delete,
    .btn-card-edit {
        flex: 1;
        justify-content: center;
    }

    .link-default-card {
        justify-content: center;
    }

    .btn-add-new-card {
        width: 100%;
        justify-content: center;
    }
}
`;

// Composant pour l'icône de la marque
const CardBrandIcon = ({ brand }) => {
    const brandLower = brand?.toLowerCase();
    switch (brandLower) {
        case 'visa': return <SiVisa />;
        case 'mastercard': return <SiMastercard />;
        case 'amex':
        case 'american express': return <SiAmericanexpress />;
        default: return <FaCreditCard />;
    }
};

// Obtenir la classe CSS selon la marque
const getCardClass = (brand) => {
    const brandLower = brand?.toLowerCase();
    const brands = ['visa', 'mastercard', 'amex', 'discover', 'diners', 'jcb', 'unionpay'];
    return brands.includes(brandLower) ? brandLower : 'default';
};

// ===== COMPOSANT PRINCIPAL =====
const UserDetails = ({
    paymentL,
    paymentMethods,
    infoSource,
    setAddCards,
    DelPaymentMethod,
    ButtonEdit,
    buttonDefaultCard,
    notPayment1,
    onShowPolicy,
    bankAccountsList,
    setAddBankAcc,
    DelBankAccount,
    ButtonEditBank,
    UpdateBankAccount
}) => {
  __setElakayInfoSource(infoSource);
    const [activeKey, setActiveKey] = useState(null);

    if (!paymentL) return null;

    const cardsCreditDetail = () => {
        if (paymentMethods?.paymentMethods?.length > 0) {
            return (
                <>
                    <h5 className="payment-section-title">
                        <FaCreditCard />
                        {infoSource.laguangeElakay('walletPage', infoSource.languageAPI).cards}
                    </h5>

                    <Accordion
                        activeKey={activeKey}
                        onSelect={(k) => setActiveKey(k)}
                        className="payment-premium-accordion"
                    >
                        {paymentMethods.paymentMethods.map((CV, i) => (
                            <Accordion.Item
                                key={i}
                                eventKey={CV.id}
                            >
                                <Accordion.Header>
                                    <div className="card-header-item">
                                        <div className={`card-brand-icon ${getCardClass(CV?.brand)}`}>
                                            <CardBrandIcon brand={CV?.brand} />
                                        </div>
                                        <div className="card-info-text">
                                            <div className="card-info-number">
                                                {CV?.brand?.toUpperCase()} •••• {CV?.last4}
                                            </div>
                                            <div className="card-info-expiry">{__elakayText("t006", "Expires")}{CV?.exp_month}/{CV?.exp_year}
                                            </div>
                                        </div>
                                    </div>
                                    {paymentMethods.defaultPaymentMethodId === CV.id && (
                                        <div className="default-card-badge">
                                            <FaCheck size={12} />{__elakayText("t007", "Default")}</div>
                                    )}
                                </Accordion.Header>

                                <Accordion.Body>
                                    <div className="card-detail-section">
                                        <div className="row">
                                            <div className="col-12 col-lg-6 mb-4 mb-lg-0">
                                                <div className="card-visual-wrapper">
                                                    {/* Utilisation de votre composant CreditCardType_ */}
                                                    <CreditCardType
                                                        cardsDetail={CV.card}
                                                        last4={CV?.last4}
                                                        brand={CV?.brand}
                                                        exp_month={CV?.exp_month}
                                                        exp_year={CV?.exp_year}
                                                        name={CV?.name}
                                                        infoSource={infoSource}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-12 col-lg-6">
                                                <div className="billing-info-section">
                                                    <h6 className="billing-info-title">
                                                        <FaShieldAlt />
                                                        {infoSource.laguangeElakay('title', infoSource.languageAPI).billingAddress}
                                                    </h6>
                                                    <div className="billing-info-content">
                                                        <strong>{CV?.name}</strong><br />
                                                        {CV.billing_details.address.line1}<br />
                                                        {CV.billing_details.address.city}<br />
                                                        {CV.billing_details.address.state}, {CV.billing_details.address.country} {CV.billing_details.address.postal_code}
                                                    </div>

                                                    <div className="card-actions">
                                                        <div className="action-buttons-group">
                                                            <button
                                                                className="btn-card-delete"
                                                                onClick={() => DelPaymentMethod(CV.id)}
                                                            >
                                                                <FaTrashAlt size={14} />
                                                                {infoSource.laguangeElakay('Button', infoSource.languageAPI).delete}
                                                            </button>
                                                            <button
                                                                className="btn-card-edit"
                                                                onClick={() => ButtonEdit(CV, true)}
                                                            >
                                                                <FaEdit size={14} />
                                                                {infoSource.laguangeElakay('Button', infoSource.languageAPI).edit}
                                                            </button>
                                                        </div>

                                                        {paymentMethods.defaultPaymentMethodId !== CV.id && (
                                                            <Link
                                                                to="#"
                                                                className="link-default-card"
                                                                onClick={() => buttonDefaultCard(CV.id)}
                                                            >
                                                                <FaStar size={14} />
                                                                {infoSource.laguangeElakay('Link', infoSource.languageAPI).setDefault}
                                                            </Link>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Accordion.Body>
                            </Accordion.Item>
                        ))}
                    </Accordion>

                    <div className="security-info-badge">
                   
                        <FaShieldAlt />{__elakayText("t002", "Your payment information is encrypted and secure")}<Link
                                    to="#"
                                    // className="header-policy-link btn-dark"
                                    onClick={() => onShowPolicy && onShowPolicy()}
                                >{__elakayText("t003", "Payment Policy")}</Link>
                    </div>
                </>
            );
        }

        return (
            <div className="empty-payment-state">
                <div className="empty-payment-icon">
                    <FaCreditCard />
                </div>
                <h4 className="empty-payment-title">{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).paymentmethodsredesign.t001}</h4>
                <p className="empty-payment-text">{__elakayText("t004", "Add a credit or debit card to start making secure payments")}</p>
            </div>
        );
    };

    const bankAccountsDetail = () => {
        if (!bankAccountsList?.length) return null;

        return (
            <>
                <h5 className="payment-section-title bank-section-title">
                    <FaUniversity />
                    {infoSource.laguangeElakay('walletPage', infoSource.languageAPI).banks}
                </h5>

                {bankAccountsList.map((CV, i) => (
                    <div key={CV.id || i} className="bank-item-card">
                        <div className="bank-item-info">
                            <div className="bank-icon-wrapper">
                                <FaUniversity />
                            </div>
                            <div>
                                <div className="bank-info-name">
                                    {CV.us_bank_account?.bank_name || __elakayText("t008", "Bank account")}
                                </div>
                                <div className="bank-info-last4">
                                    •••• {CV.us_bank_account?.last4 || "????"}
                                </div>
                            </div>
                        </div>

                        <div className="bank-item-actions">
                            <button
                                className="btn-card-delete"
                                onClick={() => DelBankAccount(CV.id)}
                            >
                                <FaTrashAlt size={14} />
                                {infoSource.laguangeElakay('Button', infoSource.languageAPI).delete}
                            </button>
                            <button
                                className="btn-card-edit"
                                onClick={() => ButtonEditBank(CV)}
                            >
                                <FaEdit size={14} />
                                {infoSource.laguangeElakay('Button', infoSource.languageAPI).edit}
                            </button>
                            <Link
                                to="#"
                                className="link-default-card"
                                onClick={() => UpdateBankAccount(CV.id, { set_default: true })}
                            >
                                <FaStar size={14} />
                                {infoSource.laguangeElakay('Link', infoSource.languageAPI).setDefault}
                            </Link>
                        </div>
                    </div>
                ))}
            </>
        );
    };

    return (
        <div className="payment-premium-container">
            <style>{premiumStyles}</style>

            <div className="payment-premium-card">
                {/* Header */}
                <div className="payment-premium-header">
                    <div className="payment-header-content">
                        <div className="payment-header-icon-wrapper">
                            <FaCreditCard size={28} color="#ffffff" />
                        </div>
                        <div className="payment-header-text">
                            <h3>{infoSource.laguangeElakay('walletPage', infoSource.languageAPI).addMethPayment}</h3>
                            <p>{__elakayText("t005", "Manage your payment methods securely •")}<Link
                                    to="#"
                                    // className="header-policy-link"
                                    onClick={() => onShowPolicy && onShowPolicy()}
                                >{__elakayText("t003", "Payment Policy")}</Link>
                            </p>
                        </div>
                    </div>
                </div>

                {/* Body */}
                <div className="payment-premium-body">
                    {cardsCreditDetail()}

                    <button
                        className="btn-add-new-card"
                        onClick={() => setAddCards(true)}
                    >
                        <FaPlus size={18} />
                        {infoSource.laguangeElakay('Button', infoSource.languageAPI).addCard}
                    </button>

                    {bankAccountsDetail()}

                    {/* <button
                        className="btn-add-new-card"
                        onClick={() => setAddBankAcc(true)}
                    >
                        <FaPlus size={18} />
                        {infoSource.laguangeElakay('Button', infoSource.languageAPI).addBank}
                    </button> */}
                </div>
            </div>
        </div>
    );
};

export default UserDetails;